/**
 * AI客户画像
 */

import React, { useEffect, useState } from 'react'
import { Card, Timeline, message, Spin } from 'antd'
import { DownOutlined, UpOutlined, InfoCircleOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { aiConfigMap } from '@pages/customer/detail/config/index'
import { getCustomerProfile, getIntentionSummary } from '@services/ai-assistant/index'
import './AiCustomerPersonas.less'
import { isEmpty, isNull, isUndefined } from 'lodash'

interface AiCustomerPersonasProps {
  title: string
  type: 'customer' | 'intention'
  expandable?: boolean
  originData?: any
  overClass?: string
  id?: string | number
  onChange?: (data) => void
}
export default function AiCustomerPersonas (props: AiCustomerPersonasProps) {
  const { title, type, expandable = true, originData, overClass, id, onChange } = props
  const [expand, setExpand] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState(originData ?? undefined)

  const currentDisplayMap = aiConfigMap[type] || aiConfigMap.customer

  useEffect(() => {
    if (!originData && id) {
      fetchData()
    } else if (!originData && !id) {
      setData(undefined)
      onChange && onChange(undefined)
    } else if (originData) {
      setData(originData)
    }
  }, [type, originData, id])

  const fetchData = () => {
    setLoading(true)
    type === 'customer' ? GetCustomerProfile(id) : GetIntentionSummary(id)
  }

  const GetCustomerProfile = async (cid) => {
    try {
      const [res, err] = await getCustomerProfile({ cid })
      setData(res)
    } catch (err) {
      message.error('获取客户画像失败' + err.message)
    } finally {
      setLoading(false)
    }
  }

  const GetIntentionSummary = async (leadId) => {
    try {
      const [res, err] = await getIntentionSummary({ leadId })
      onChange && onChange(res.intentionSummary)
      setData(res.intentionSummary)
    } catch (err) {
      message.error('获取意向提炼失败' + err.message)
    } finally {
      setLoading(false)
    }
  }

  const renderTitle = () => {
    if (!expandable) return title
    return (
      <div className="custom-card-title" onClick={() => setExpand(!expand)}>
        {expand ? <DownOutlined /> : <UpOutlined />}{title || '💡AI客户画像'}
      </div>
    )
  }

  if (!data && !loading && type === 'customer') {
    return null
  }

  return (
    <Card
      style={{ width: 400, maxHeight: expandable ? 300 : 'none', overflow: 'auto' }}
      className={classNames('custom-card-fixed', { 'custom-card-content-expand': expand }, overClass)}
      title={renderTitle()}
    >
      {!expand && (
        <Spin spinning={loading}>
          <div className="custom-card-content mt10">
            {type !== 'customer' && isEmpty(data) && !id && (
              <div className="ai-customer-personas-empty-tips">请先选择线索</div>
            )}
            {type !== 'customer' && isEmpty(data) && id && (
              <div className="ai-customer-personas-empty-tips">暂无</div>
            )}
            {type === 'intention' && !isEmpty(data) && <p className="weak-tips"><InfoCircleOutlined twoToneColor="#a8aebd" /> 针对意向线索 {id} 的通话AI意向提炼</p>}
            {!isUndefined(data) && !isNull(data) && (
              <Timeline>
                {currentDisplayMap?.fieldList?.map((item) => (
                  <Timeline.Item key={item?.key}>
                    <div>
                      <div className="title">{item?.label}</div>
                      <div className="content">
                        {(item?.children as Array<{ label: string; key: string; autoDisplay: boolean }>)?.map(n => {
                          // 特殊逻辑 【竞品分析】字段返回的结构是多个字段组合起来的 需要拆分
                          if (n?.key === 'adoption') {
                            return <p key={n?.key} className="item-info" dangerouslySetInnerHTML={{ __html: data?.[n?.key]?.replace(/【/g, '<br />【')?.replace(/^<br \/>/, '') || '暂无' }} />
                          }
                          return <p key={n?.key} className="item-info">{n?.label}{data?.[n?.key]}</p>
                        })}
                      </div>
                    </div>
                  </Timeline.Item>
                ))}
              </Timeline>
            )}
          </div>
        </Spin>
      )}
    </Card>
  )
}
